export const TicketHorizontal = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M28.9999 25H3V19C4 19 6 18 6 16C6 14 4 13 3 13V7H28.9999V13C27.9999 13.0156 25.9999 13.6373 25.9999 16C25.9999 18.3627 27.9999 18.9845 28.9999 19V25Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M20 7V11" stroke="currentColor" stroke-width="2"/>
<path d="M20 13V19" stroke="currentColor" stroke-width="2"/>
<path d="M20 21V25" stroke="currentColor" stroke-width="2"/>
</svg>`;
